import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
// const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const onAuth = r => require.ensure([], () => r(require('@/page/onAuth')), 'onAuth');
const loginAuth = r => require.ensure([], () => r(require('@/page/loginAuth')), 'loginAuth');
const homeAuto = r => require.ensure([], () => r(require('@/page/homeAuto')), 'homeAuto');
// const HelloWorld = r => require.ensure([], () => r(require('@/components/HelloWorld')), 'HelloWorld');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
const home = r => require.ensure([], () => r(require('@/page/home')), 'home');
const maintenance = r => require.ensure([], () => r(require('@/page/maintenance')), 'maintenance');



const eventList = r => require.ensure([], () => r(require('@/page/eventList')), 'eventList');
const eventListDetails = r => require.ensure([], () => r(require('@/page/eventListDetails')), 'eventListDetails');
const manageParticipants = r => require.ensure([], () => r(require('@/page/manageParticipants')), 'manageParticipants');
const eventParticipationRequestForm = r => require.ensure([], () => r(require('@/page/eventParticipationRequestForm')), 'eventParticipationRequestForm');
const manageProfile = r => require.ensure([], () => r(require('@/page/manageProfile')), 'manageProfile');

const contactUs = r => require.ensure([], () => r(require('@/page/contactUs')), 'contactUs');
const footerPage = r => require.ensure([], () => r(require('@/page/footerPage')), 'footerPage');
const imprint = r => require.ensure([], () => r(require('@/page/imprint')), 'imprint');
const legalDisclaimer = r => require.ensure([], () => r(require('@/page/legalDisclaimer')), 'legalDisclaimer');
const privacyPolicy = r => require.ensure([], () => r(require('@/page/privacyPolicy')), 'privacyPolicy');


const routes = [
  // {
  //   path: "/login",
  //   component: login,
  //   name: "login",
  // },
  // {
  //   path: "/HelloWorld",
  //   component: HelloWorld,
  //   name: "HelloWorld",
  // },
  {
    path: "/",
    component: homeAuto,
    name: "homeAuto",
    meta: {
      title: 'Home'
    }
  },
  {
    path: "/loginAuth",
    component: loginAuth,
    name: "loginAuth",
    meta: {
      title: 'Login'
    }
  },
  {
    path: "/onAuth",
    component: onAuth,
    name: "onAuth",
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/manage',
    name: '/manage',
    component: manage,
    children: [{
      path: '',
      name: '',
      meta: [],
    },
    {
      path: '/home',
      name:'home',
      component: home,
      meta: {
          // breadcrumb:['list.masterData', 'masterDataName'],
          keepAlive:true,
          isBack:false,
          title: 'Home'
      }
    },
    {
      path: '/maintenance',
      name:'maintenance',
      component: maintenance,
      meta: {
          keepAlive:false,
          isBack:false,
          title: 'maintenance'
      }
    },
    {
      path: '/eventList',
      name:'eventList',
      component: eventList,
      meta: {
          // breadcrumb:['list.masterData', 'masterDataName'],
          keepAlive:true,
          isBack:false,
          title: 'Event List'
      }
    },
    {
      path: '/eventListDetails',
      name:'eventListDetails',
      component: eventListDetails,
      meta: {
          // breadcrumb:['list.masterData', 'masterDataName'],
          keepAlive:true,
          isBack:false,
          title: 'Event Detail'
      },
    },
    {
      path: '/manageParticipants',
      name:'manageParticipants',
      component: manageParticipants,
      meta: {
          // breadcrumb:['list.masterData', 'masterDataName'],
          keepAlive:true,
          isBack:false,
          title: 'Manage Participants'
      },
    },
    {
      path: '/eventParticipationRequestForm',
      name:'eventParticipationRequestForm',
      component: eventParticipationRequestForm,
      meta: {
          // breadcrumb:['list.masterData', 'masterDataName'],
          keepAlive:true,
          isBack:false,
          title: 'Event Request Form'
      },
    },
    {
      path: '/manageProfile',
      name:'manageProfile',
      component: manageProfile,
      meta: {
          keepAlive:true,
          isBack:false,
          title: 'Manage Profile'
      },
    },

    {
      path: '/contactUs',
      name:'contactUs',
      component: footerPage,
      meta: {
          keepAlive:true,
          isBack:false,
          title: 'Kontakt'
      },
    },
    {
      path: '/footerPage',
      name:'footerPage',
      component: footerPage,
      meta: {
          keepAlive:true,
          isBack:false,
          title: ''
      },
    },
    {
      path: '/imprint',
      name:'imprint',
      component: footerPage,
      meta: {
          keepAlive:true,
          isBack:false,
          title: 'Impressum'
      },
    },
    {
      path: '/legalDisclaimer',
      name:'legalDisclaimer',
      component: footerPage,
      meta: {
          keepAlive:true,
          isBack:false,
          title: 'Cookie Einstellungen'
      },
    },
    {
      path: '/privacyPolicy',
      name:'privacyPolicy',
      component: footerPage,
      meta: {
          keepAlive:true,
          isBack:false,
          title: 'Datenschutzrichtlinie​'
      },
    },
    
    
    
  ]}
]

export default new Router({
  routes,
  // strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js